const affiliates = [
  {
    text: 'footer.ledger',
    price: '59.00',
    description: 'buyHardwareWallet.desc.ledger',
    href: 'https://www.ledger.com?r=fa4b',
    currency: '$',
    logo: 'ledger'
  },
  {
    text: 'footer.ethCard',
    price: '',
    description: '',
    href:
      'https://ether.cards/?utm_source=mew&utm_medium=cpm&utm_campaign=site',
    currency: '',
    logo: ''
  },
  {
    text: 'footer.bity',
    price: '',
    description: '',
    href: 'https://bity.com/af/jshkb37v',
    currency: '',
    logo: ''
  },
  {
    text: 'footer.billfodl',
    price: '',
    description: '',
    href:
      'https://billfodl.com/?afmc=2j&utm_campaign=2j&utm_source=leaddyno&utm_medium=affiliate',
    currency: '',
    logo: ''
  },
  {
    text: 'footer.finney',
    price: '999.00',
    description: 'buyHardwareWallet.desc.finney',
    href:
      'http://shop.sirinlabs.com?rfsn=2397639.54fdf&utm_source=refersion&utm_medium=affiliate&utm_campaign=2397639.54fdf',
    currency: '$',
    logo: 'finney'
  },
  // {
  //   text: 'footer.bitbox',
  //   price: '44.00',
  //   description: 'buyHardwareWallet.desc.bitbox',
  //   href: 'https://shiftcrypto.ch/?ref=MEW',
  //   currency: '€',
  //   logo: 'bitbox'
  // },
  {
    text: 'footer.trezor',
    price: '83.49',
    description: 'buyHardwareWallet.desc.trezor',
    href: 'https://trezor.io/?offer_id=12&aff_id=2029',
    currency: '€',
    logo: 'trezor'
  },
  {
    text: 'footer.secalot',
    price: '50.00',
    description: 'buyHardwareWallet.desc.secalot',
    href: 'https://www.secalot.com/',
    currency: '$',
    logo: 'secalot'
  },
  {
    text: 'footer.keepkey',
    price: '79.00',
    description: 'buyHardwareWallet.desc.keepkey',
    href: 'http://lddy.no/a4im',
    currency: '$',
    logo: 'keepkey'
  },
  {
    text: 'footer.cool-wallet',
    price: '99.00',
    description: 'buyHardwareWallet.desc.coolwallet',
    href: 'https://www.coolwallet.io/mew/?ref=myetherwallet1',
    currency: '$',
    logo: 'coolwallet'
  },
  {
    text: 'footer.sotd',
    price: '',
    description: '',
    href: 'https://www.stateofthedapps.com/',
    currency: '',
    logo: ''
  },
  {
    text: 'footer.bcvault',
    price: '131.14',
    description: 'buyHardwareWallet.desc.bcvault',
    href: 'https://bc-vault.com/?wpam_id=53',
    currency: '€',
    logo: 'bcvault'
  }
];

export default affiliates;
